import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-normal" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'SectionHeading',
    props: {
        align: { type: String, default: 'center' },
        heading: { type: String, required: true },
        size: { type: String, default: 'text-5xl' },
        subheading: { type: String, default: null },
        truncate: { type: Boolean, default: false }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mb-8 text-primary-900 dark:text-gray-300 max-w-155", {
                        'mx-auto text-center': __props.align === 'center'
                    }])
            }, [
                _createElementVNode("h2", {
                    class: _normalizeClass(`font-bold ${!!_ctx.$slots.default ? 'flex items-end' : ''} ${__props.truncate ? 'truncate' : ''} ${__props.size}`)
                }, [
                    _renderSlot(_ctx.$slots, "default"),
                    _createTextVNode(" " + _toDisplayString(__props.heading), 1)
                ], 2),
                _createElementVNode("p", _hoisted_1, _toDisplayString(__props.subheading), 1)
            ], 2));
        };
    }
});
